module.exports = __webpack_public_path__ + "media/entities/1123-feca90d3.png";